<script>
  // [05/23] https://tailwindui.com/components/application-ui/elements/buttons
  import HiArrowsPointingOut from '../heroicons/HiArrowsPointingOut.svelte';
  import HiArrowUturnLeft from '../heroicons/HiArrowUturnLeft.svelte';
  import HiBars3 from '../heroicons/HiBars3.svelte';
  import HiCheck from '../heroicons/HiCheck.svelte';
  import HiCheckCircle from '../heroicons/HiCheckCircle.svelte';
  import HiChevronDown from '../heroicons/HiChevronDown.svelte';
  import HiChevronUp from '../heroicons/HiChevronUp.svelte';
  import HiChevronUpDown from '../heroicons/HiChevronUpDown.svelte';
  import HiExclamationCircle from '../heroicons/HiExclamationCircle.svelte';
  import HiInformationCircle from '../heroicons/HiInformationCircle.svelte';
  import HiPlus from '../heroicons/HiPlus.svelte';
  import HiTrash from '../heroicons/HiTrash.svelte';
  import HiXCircle from '../heroicons/HiXCircle.svelte';

  export let value = undefined;
  export let icon = undefined;
  export let onClick;
  export let cssClass = undefined;
</script>

<div class="tailwind button-secondary {cssClass || ''}">
  <button on:click={onClick} type="button" class="inline-flex items-center gap-x-1.5 rounded-md bg-white dark:bg-neutral-800 px-3 py-2 text-sm font-semibold text-neutral-900 dark:text-white shadow-sm ring-1 ring-inset ring-neutral-300 dark:ring-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:focus-visible:outline-blue-500">
    {#if icon === 'arrows-pointing-out'}
      <HiArrowsPointingOut cssClass="h-5 w-5"/>
    {:else if icon === 'arrow-u-turn-left'}
      <HiArrowUturnLeft cssClass="h-5 w-5"/>
    {:else if icon === 'bars-3'}
      <HiBars3 cssClass="h-5 w-5"/>
    {:else if icon === 'check'}
      <HiCheck cssClass="h-5 w-5"/>
    {:else if icon === 'check-circle'}
      <HiCheckCircle cssClass="h-5 w-5"/>
    {:else if icon === 'chevron-up'}
      <HiChevronUp cssClass="h-5 w-5"/>
    {:else if icon === 'chevron-down'}
      <HiChevronDown cssClass="h-5 w-5"/>
    {:else if icon === 'chevron-up-down'}
      <HiChevronUpDown cssClass="h-5 w-5"/>
    {:else if icon === 'exclamation-circle'}
      <HiExclamationCircle cssClass="h-5 w-5"/>
    {:else if icon === 'information-circle'}
      <HiInformationCircle cssClass="h-5 w-5"/>
    {:else if icon === 'plus'}
      <HiPlus cssClass="h-5 w-5"/>
    {:else if icon === 'trash'}
      <HiTrash cssClass="h-5 w-5"/>
    {:else if icon === 'x-circle'}
      <HiXCircle cssClass="h-5 w-5"/>
    {/if}

    {#if value}
      {value}
    {/if}
  </button>
</div>
